module.exports = __webpack_public_path__ + "static/media/plp_fit_icon.e2652717.svg";